import { createContext } from 'react';

export const MainHeaderHeightContext = createContext(0);
